export default __webpack_public_path__ + "static/media/resume.61742508.pdf";